module.exports = __webpack_public_path__ + "static/img/2gaofen2.b5c20461.png";